import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";

export class working_time extends entityBase {
  req_type: KnockoutObservable<string>;
  request_attachment: KnockoutObservable<string>;
  request_id: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;
  task_type: KnockoutObservable<string>;
  model: KnockoutObservable<string>;
  serial_no: KnockoutObservable<string>;
  created_dt: KnockoutObservable<Date>;
  created_dttm: KnockoutObservable<any>;
  plan_start_dt: KnockoutObservable<Date>;
  plan_start_date: KnockoutObservable<any>;
  plan_end_dt: KnockoutObservable<Date>;
  plan_end_date: KnockoutObservable<any>;
  status: KnockoutObservable<string>;
  // assign_technician: KnockoutObservable<string>;
  prioTaskColor: KnockoutObservable<string>;
  slaTaskColor: KnockoutObservable<string>;
  prioTask: KnockoutObservable<string>;
  user_def8: KnockoutObservable<any>;

  constructor(item: any) {
    super();
    this.request_attachment = ko.observable(item.request_attachment).extend({ maxLength: 128 });
    this.req_type = ko.observable(item.req_type).extend({ maxLength: 128 });
    this.request_id = ko.observable(item.request_id).extend({ maxLength: 128 });
    this.task_id = ko.observable(item.task_id).extend({ maxLength: 128 });
    this.task_type = ko.observable(item.task_type).extend({ maxLength: 128 });
    this.model = ko.observable(item.model_id).extend({ maxLength: 128 });
    this.serial_no = ko.observable(item.serial_id).extend({ maxLength: 128 });
    this.created_dt = ko.observable(this.formatJSONDate(item.created_dttm));
    this.created_dttm = CustomObservables.formattedDateTimeObservable(this.created_dt);
    this.plan_start_dt = ko.observable(this.formatJSONDate(item.plan_start_dttm));
    this.plan_start_date = CustomObservables.formattedDateTimeObservable(this.plan_start_dt);
    this.plan_end_dt = ko.observable(this.formatJSONDate(item.plan_end_dttm));
    this.plan_end_date = CustomObservables.formattedDateTimeObservable(this.plan_end_dt);
    this.status = ko.observable(item.task_status).extend({ maxLength: 128 });
    // this.assign_technician = ko.observable(item.assign_technician).extend({maxLength: 128});
    this.user_def8 = ko.observable(item.user_def8).extend({ maxLength: 128 });
    this.prioTaskColor = ko.observable(item.user_def8).extend({ maxLength: 128 });
    if (item.global_code_table) {
      this.prioTask = ko.observable(item.global_code_table.description).extend({ maxLength: 128 });
    } else {
      this.prioTask = ko.observable();
    }

    let currentDate = ko.observable(new Date());
    let minimOneDay = (currentDate) => new Date(currentDate().setDate(currentDate().getDate() - 1));
    let minimOneHour = (currentDate) => new Date(currentDate().setDate(currentDate().getHours() - 1));
    let currentTime = () => new Date();
    this.slaTaskColor = ko.pureComputed(() => {
      if (this.plan_end_date < minimOneDay) {
        return "#FF0000";
      } else if (this.plan_end_date < minimOneHour) {
        return "#FF6A00";
      } else if (this.plan_end_date < currentTime) {
        return "#FFD800";
      } else {
        return "#4CFF00";
      }
    }, this);
    this.prioTaskColor = ko.pureComputed(() => {
      switch (item.user_def8) {
        case "6":
          return "#FF0000";
        case "1":
          return "#FF6A00";
        case "2":
          return "#FFD800";
        case "3":
          return "#FFE97F";
        case "4":
          return "#4CFF00";
        case "5":
          return "#0094FF";
      }
      return "#fff";
    }, this);
  }
}
